import { Navigate } from 'react-router-dom';
import { useAppSelector } from '../../store';
import { DASHBOARD } from '../../constants/auth';
import { canAccessInvoicing } from '../../utils/invoicing';
import InvoicingSkeleton from '../../viewsv2/Invoicing/skeleton';

type InvoicingAccessGuardProps = {
  children: React.ReactNode;
};

const InvoicingAccessGuard = ({ children }: InvoicingAccessGuardProps) => {
  const selectedCompany = useAppSelector(
    (state) => state.companyUser.companyUser?.selectedCompany
  );

  if (!selectedCompany) {
    return <InvoicingSkeleton />;
  }

  if (!canAccessInvoicing(selectedCompany)) {
    return <Navigate to={DASHBOARD} replace />;
  }

  return <>{children}</>;
};

export default InvoicingAccessGuard;
